import * as type from "../../types/API/customForms";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
  successMessage: '',
  deleteSuccessMessage: ''
};

export const getCustomFormsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_CUSTOM_FORMS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_CUSTOM_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData
      };
    case type.GET_CUSTOM_FORMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addCustomFormsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_CUSTOM_FORMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_CUSTOM_FORMS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData.data,
        successMessage: action.payload.responseData.message
      };
    case type.ADD_CUSTOM_FORMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editCustomFormsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_CUSTOM_FORMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_CUSTOM_FORMS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.responseData.data,
        successMessage: action.payload.responseData.message
      };
    case type.EDIT_CUSTOM_FORMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteCustomFormsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_CUSTOM_FORMS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_CUSTOM_FORMS_SUCCESS:
      return {
        error: null,
        loading: false,
        deleteSuccessMessage: action?.payload?.responseData?.message
      };
    case type.DELETE_CUSTOM_FORMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
